class ThemeDocumentElement {
  constructor() {
    this.SetTheme = this.SetTheme.bind(this);
  }

  SetTheme(theme) {
    window.document.documentElement.className = theme;
  }
}

export default ThemeDocumentElement;
